import React from "react";
import { useTranslation } from "react-i18next";
import ShieldCard from "../../../components/shield-card/ShieldCard";
import ActiveShieldIcon from "../../../components/icons/ActiveShieldIcon";
import { DashboardStatisticsType } from "../../../types/dashboard";

interface DashboardStatsProps {
  stats?: DashboardStatisticsType;
  loading?: boolean;
}

export default function DashboardStats({
  stats,
  loading = false,
}: DashboardStatsProps) {
  const { t } = useTranslation(["dashboard"]);

  const data = [
    {
      name: t("stats.total_covers", { ns: "dashboard" }),
      qty: stats?.coverDetails?.totalCovers,
      shieldColor: "bg-active-covers-shield",
      icon: <ActiveShieldIcon />,
      tooltip: t("stats.tooltip.total_covers", { ns: "dashboard" }),
      url: "/my-covers",
    },
    {
      name: t("stats.active_covers", { ns: "dashboard" }),
      qty: stats?.coverDetails?.activeCovers,
      color: "bg-active-covers",
      shieldColor: "bg-active-covers-shield",
      icon: <ActiveShieldIcon />,
      tooltip: t("stats.tooltip.active_covers", { ns: "dashboard" }),
      url: "/my-covers",
    },
    {
      name: t("stats.pending_covers", { ns: "dashboard" }),
      qty: stats?.coverDetails?.pendingCovers,
      color: "bg-pending-covers",
      shieldColor: "bg-pending-covers-shield",
      icon: <ActiveShieldIcon />,
      tooltip: t("stats.tooltip.pending_covers", { ns: "dashboard" }),
      url: "/my-covers",
    },
    {
      name: t("stats.total_claims", { ns: "dashboard" }),
      qty: stats?.coverDetails?.totalClaims,
      shieldColor: "bg-active-covers-shield",
      icon: <ActiveShieldIcon />,
      tooltip: t("stats.tooltip.total_claims", { ns: "dashboard" }),
      url: "/my-claims",
    },
    {
      name: t("stats.active_claims", { ns: "dashboard" }),
      qty: stats?.coverDetails?.activeClaims,
      color: "bg-active-claims",
      shieldColor: "bg-active-claims-shield",
      icon: <ActiveShieldIcon />,
      tooltip: t("stats.tooltip.active_claims", { ns: "dashboard" }),
      url: "/my-claims",
    },
    {
      name: t("stats.pending_claims", { ns: "dashboard" }),
      qty: stats?.coverDetails?.PendingClaims,
      color: "bg-pending-claims",
      shieldColor: "bg-pending-claims-shield",
      icon: <ActiveShieldIcon />,
      tooltip: t("stats.tooltip.pending_claims", { ns: "dashboard" }),
      url: "/my-claims",
    },
  ];
  return (
    <>
      <div className="row ">
        {data.map((stat) => {
          return (
            <div className="col-6 col-md-4 mb-3" key={stat.name}>
              <ShieldCard
                name={stat.name}
                qty={stat.qty}
                color={stat.color}
                shieldColor={stat.shieldColor}
                icon={stat.icon}
                tooltip={stat.tooltip}
                url={stat.url}
                loading={loading}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
